// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FormatService {
  formatFeatureDescription(details: string): string {
    const withNewlines = this.replaceNewlineMarkers(details);
    const withBullets = this.replaceBulletMarkers(withNewlines);
    const withBold = this.replaceBoldMarkers(withBullets);
    const withItalics = this.replaceItalicsMarkers(withBold);
    const withUrls = this.checkForUrls(withItalics);
    return withUrls;
  }

  private replaceNewlineMarkers(details: string): string {
    return details.replace(/<newline>/g, '<br>');
  }

  private replaceBulletMarkers(details: string): string {
    return details.replace(/<bullet>/g, '<br>&#8226; ');
  }

  private replaceBoldMarkers(details: string): string {
    return details
      .replace(/<bold>/g, '<strong>')
      .replace(/<\/bold>/g, '</strong>');
  }

  private replaceItalicsMarkers(details: string): string {
    return details
      .replace(/<italics>/g, '<em>')
      .replace(/<\/italics>/g, '</em>');
  }

  private checkForUrls(details: string): string {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return details.replace(urlRegex, '<a href="$1" target="_blank">$1</a>');
  }
}
